import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamEntrypointQuery } from "../graphql/queries";
import type {
  StreamEntrypointQueryType,
  StreamEntrypointQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamEntrypointQuery = (
  options?: QueryHookOptions<
    StreamEntrypointQueryType,
    StreamEntrypointQueryVariablesType
  >
) => {
  return useQuery<
    StreamEntrypointQueryType,
    StreamEntrypointQueryVariablesType
  >(StreamEntrypointQuery, options);
};
